module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q1.0fcf8dad.png";